import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { ISubmittedDocumentsStatusType } from '../interfaces/ISubmittedDocumentsStatusType';

export async function fetchErknmSubmittedDocumentsStatusType(): Promise<ISubmittedDocumentsStatusType[]> {
  return apiGet<ISubmittedDocumentsStatusType[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/submitted-document-statuses`,
  );
}
